/**
 * Application API service
 * @module features/applications/applicationService
 */

import api from '../../app/axios';

const getApplications = async (params) => {
  const response = await api.get('/activities', { params });
  return response.data;
};

const getApplicationBySlug = async (slug) => {
  const response = await api.get(`/activities/slug/${slug}`);
  return response.data;
};

const getApplicationById = async (id) => {
  const response = await api.get(`/activities/${id}`);
  return response.data;
};

const createApplication = async (data) => {
  const response = await api.post('/activities', data);
  return response.data;
};

const updateApplication = async (id, data) => {
  const response = await api.put(`/activities/${id}`, data);
  return response.data;
};

const deleteApplication = async (id) => {
  const response = await api.delete(`/activities/${id}`);
  return response.data;
};

const applicationService = {
  getApplications,
  getApplicationBySlug,
  getApplicationById,
  createApplication,
  updateApplication,
  deleteApplication,
};

export default applicationService;

// Developed and Designed by Trophy Developers
